// extracted by mini-css-extract-plugin
module.exports = {"button":"expanding-plus-button_button__cnGjA","open-icon":"expanding-plus-button_open-icon__JKohz","close-icon":"expanding-plus-button_close-icon__pUcRY"};